import React, { useState } from "react"

import { buildMutation, compress, useMutation } from "micro-graphql-react"

import { parentClient as client } from "src/graphql-config"
import ordered from "src/ordered"

import EditableList from "components/EditableList"
import RemoveButton from "components/RemoveButton"

const CurrentTeacherSubjects = ({ studentId, teacherSubjects }) => {
  const [errors, setErrors] = useState()
  const { runMutation } = useMutation(
    buildMutation(removeTeacherSubjectMutation, { client })
  )

  const removeTeacherSubject = teacherSubjectId => {
    runMutation({ teacherSubjectId, studentId })
      .then(
        response => {
          const { errorMessages } = response.teacherSubjectRemove
          if (errorMessages) {
            setErrors(errorMessages)
          }
        },
        () => setErrors("Something went wrong")
      )
      .catch(() => setErrors("Something went wrong"))
  }

  return (
    <>
      {errors && <div className="alert">{errors}</div>}
      <EditableList>
        {ordered(
          ordered(teacherSubjects, "teacher", "lastName"),
          "subject",
          "name"
        ).map(({ id, teacher, subject }) => (
          <li key={id} className="flex items-center">
            <RemoveButton onClick={() => removeTeacherSubject(id)} />
            <span>
              {teacher.fullName}: {subject.name}
            </span>
          </li>
        ))}
      </EditableList>
    </>
  )
}

const removeTeacherSubjectMutation = compress`
  mutation($teacherSubjectId: ID!, $studentId: ID!) {
    teacherSubjectRemove(teacherSubjectId: $teacherSubjectId, studentId: $studentId) {
      errorMessages
      removedTeacherSubjectId
    }
  }
`

export default CurrentTeacherSubjects
